module.exports = __webpack_public_path__ + "static/img/irole.09d8f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/sy/irole.png
// module id = rYSj
// module chunks = 7